/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Button,
} from '@mui/material';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import FolderIcon from '@mui/icons-material/Folder';
import { Virtuoso } from 'react-virtuoso';

export default function Sidebar({ history, onSelect, onFilterDateChange }) {
  const [sidebarHeight, setHeight] = useState(Math.max(0, window.innerHeight - 64));
  const [filterDate, setFilterDate] = useState('');

  useEffect(() => {
    const onResize = () => setHeight(Math.max(0, window.innerHeight - 64));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const items = useMemo(() => {
    return Array.isArray(history) ? history : [];
  }, [history]);

  useEffect(() => {
    if (!onFilterDateChange) return;
    if (filterDate) {
      const iso = dayjs(filterDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
      onFilterDateChange(iso);
    } else {
      onFilterDateChange(undefined);
    }
  }, [filterDate, onFilterDateChange]);

  const throwError = () => {
    throw new Error('🔥 Simulated test error — do not panic!');
  };

  return (
    <Box
      sx={{
        width: 320,
        borderRight: '1px solid #eaecef',
        position: 'fixed',
        top: 64,
        left: 0,
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 64px)',
      }}
    >
      <Box sx={{ p: 2, pb: 1 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            Uploaded Files
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{ width: 160 }}>
            <DatePicker
              value={filterDate ? dayjs(filterDate) : null}
              onChange={(d, dateString) => setFilterDate(dateString || '')}
              size="small"
              allowClear
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
            />
          </Box>
          <Button size="small" variant="text" onClick={() => setFilterDate('')}>
            Clear
          </Button>
          {/* <Button size="small" variant="text" onClick={throwError}>
            throw
          </Button> */}
        </Stack>

        <Divider sx={{ mt: 1 }} />
      </Box>
      {items.length === 0 ? (
        <Typography variant="body2" sx={{ px: 2, color: 'text.secondary' }}>
          No files yet.
        </Typography>
      ) : (
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <Virtuoso
            style={{ height: Math.max(0, sidebarHeight - 120), width: 320 }}
            totalCount={items.length}
            itemContent={(index) => {
              const f = items[index];
              const uploaded = f?.uploaded_at ? new Date(f.date).toLocaleString() : '';
              const metaParts = [];
              if (typeof f?.total_rows === 'number') metaParts.push(`${f.total_rows} rows`);
              if (uploaded) metaParts.push(uploaded);
              const secondary = metaParts.join(' • ');
              return (
                <ListItemButton key={f?._id || index} onClick={() => onSelect && f && onSelect(f)}>
                  <ListItemIcon>
                    <FolderIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={f?.file_name || ''}
                    secondary={secondary}
                    primaryTypographyProps={{
                      fontSize: 14,
                      noWrap: true,
                      title: f?.file_name || '',
                    }}
                    secondaryTypographyProps={{ fontSize: 12, color: 'text.secondary' }}
                  />
                </ListItemButton>
              );
            }}
          />
        </Box>
      )}
    </Box>
  );
}
